export default "__VITE_ASSET__DrMa8PF4__"